import api from '@pray/shared/utils/api';

const MAX_BATCH_SIZE = 100;

export async function getAnnouncementMetrics({ artistId, announcementId }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!announcementId) throw Error('Announcement ID is required');

  const url = `/web/studio/artists/${artistId}/announcements/${announcementId}/metrics`;
  const response = await api.executeGetRequest(url);

  return response.data;
}

export async function getAnnouncementMetricsBatch({ artistId, announcementIds }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!Array.isArray(announcementIds) || announcementIds.length === 0) {
    throw Error('At least one announcement ID is required');
  }

  const url = `/web/studio/artists/${artistId}/announcements/metrics`;
  const uniqueAnnouncementIds = [...new Set(announcementIds)];
  const requests = [];

  for (let offset = 0; offset < uniqueAnnouncementIds.length; offset += MAX_BATCH_SIZE) {
    const ids = uniqueAnnouncementIds.slice(offset, offset + MAX_BATCH_SIZE).join(',');
    requests.push(api.executeGetRequest(url, { ids }));
  }

  const responses = await Promise.all(requests);
  const results = responses.map((response) => response.data.data);
  const metrics = results.flatMap((result) => result.metrics ?? []);
  const pendingAnnouncementIds = results.flatMap((result) => result.pending_announcement_ids ?? []);
  let availability = metrics.length > 0 ? 'available' : 'pending';
  if (results.some((result) => result.availability === 'unavailable')) availability = 'unavailable';

  return {
    availability,
    metrics,
    pending_announcement_ids: pendingAnnouncementIds,
  };
}
